module.exports = __webpack_public_path__ + "img/Menu_Abos_Konfig.cd98067c.jpg";